import { injectable } from "@launchtray/tsyringe-async";
import { InfoModel } from "../model/InfoModel";

@injectable()
export class InfoController {
    public constructor(
        private readonly infoViewModel: InfoModel
    ) {
    }

    public nextPage(): void {
        this.infoViewModel.nextPage();
    }

    public previousPage(): void {
        this.infoViewModel.previousPage();
    }
}